/* ============================================================
   ARKAVEDA PREMIUM OFFERS — COPY CODE
============================================================ */
(function () {
  'use strict';

  function initArkPremiumOffers() {
    var buttons = document.querySelectorAll('.ark-premium-offer-card__copy');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      if (button.getAttribute('data-ready') === 'true') return;
      button.setAttribute('data-ready', 'true');

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var code = button.getAttribute('data-offer-code');
        if (!code) return;

        var textElement = button.querySelector('.ark-premium-copy-text');
        var originalText = textElement ? textElement.textContent : 'COPY';

        function copied() {
          if (textElement) textElement.textContent = 'COPIED';
          button.classList.add('is-copied');
          setTimeout(function () {
            if (textElement) textElement.textContent = originalText;
            button.classList.remove('is-copied');
          }, 1800);
        }

        function fallbackCopy() {
          var input = document.createElement('input');
          input.value = code;
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          input.setSelectionRange(0, 99999);
          try {
            document.execCommand('copy');
            copied();
          } catch (error) { /* Copy failed */ }
          document.body.removeChild(input);
        }

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code)
            .then(copied)
            .catch(fallbackCopy);
        } else {
          fallbackCopy();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArkPremiumOffers);
  } else {
    initArkPremiumOffers();
  }
})();